import React, { useState, useEffect } from "react";
import Notification from "../../../shared/general/Notification";
import ConfirmDialog from "../../../shared/general/ConfirmDialog";
import { useHistory } from "react-router-dom";
import Pagination from "../../../shared/general/Pagination";
import { styled } from "@mui/styles";

import FindInPageIcon from "@mui/icons-material/FindInPage";
import SearchIcon from "@mui/icons-material/Search";
import VpnKeyRoundedIcon from "@mui/icons-material/VpnKeyRounded";
import FlagIcon from "@mui/icons-material/Flag";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import ShowMiniData from "../../../shared/pages/okrs/components/ShowMiniData";

import { useSelector, useDispatch } from "react-redux";
import {
  getAllOrgPlan,
  deleteOrgPlan,
} from "../../../../../actions/OrganizationPlans";

import {
  Grid,
  Button,
  Toolbar,
  TextField,
  InputAdornment,
  Typography,
  Avatar,
  LinearProgress,
  Container,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles(() => ({
  root: {
    "& .MuiGrid-container": {
      marginBottom: "0 !important",
    },
    "& .MuiCardContent-root": {
      padding: 0,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 16,
    },
  },
  newBtn: {
    color: "#4f65df",
    paddingLeft: 32,
    paddingRight: 32,
    border: "2px solid #4f65df",
    borderRadius: 8,
    height: 48,
    
  },
  deleteBtn: {
    color: "#e53935",
    fontWeight: "600",
  },
  quater: {
    backgroundColor: "#e53935",
    fontWeight: "600",
    width: 48,
    height: 48,
  },
  PlanList_Object: {
    fontSize: "1.3rem",
    fontWeight: "600",
    color: "#222f3e",
  },
  PlanList_Impact: {
    color: "#9e9e9e",
    marginTop: 8,
   
  },
  PlanList_KR: {
    color: "#222f3e",
    fontSize: "1.1rem",
    fontWeight: "700",
  },
  PlanList_Status: {
    // display: 'flex',
    alignItems: "center",
    color: "#9e9e9e",
    marginBottom: 8,
  },
  moreButton_cardPlan: {
    borderRadius: "50px",
    border: "1px solid rgba(0, 0, 0, 0.23)",
  },
  noData_Section: {
    display: "flex",
    alignItems: "center",
  },
  noDataSvg: {
    fontSize: "30px",
    marginRight: 8,
  },
  inProgress: {
    backgroundColor: "#eeeeee",
    color: "#9e9e9e",
    width: "100px",
    borderRadius: "15px",
    padding: "5px 10px 5px 10px",
    textAlign: "center",
    marginLeft: 8,
    "&:hover": {
      backgroundColor: "#eeeeee",
    },
  },
  achieved: {
    backgroundColor: "#e0f2f1",
    color: "#009688",
    width: "90px",
    borderRadius: "15px",
    padding: "5px",
    textAlign: "center",
    marginLeft: 8,
    "&:hover": {
      backgroundColor: "#e0f2f1",
    },
  },
  notAchieved: {
    backgroundColor: "#f9dde0",
    color: "#c62828",
    width: "130px",
    borderRadius: "15px",
    padding: "5px",
    textAlign: "center",
    marginLeft: 8,
    "&:hover": {
      backgroundColor: "#f9dde0",
    },
  },
  viewBtn: {
    cursor: "pointer",
    backgroundColor: "#e6eaff",
    color: "#4f65df",
    width: 40,
    height: 40,
    marginRight: 8,
    marginTop: 8,
  },
  cardList_Edit: {
    cursor: "pointer",
    backgroundColor: "#fff3e0",
    color: "#ff9800",
    width: 40,
    height: 40,
    marginRight: 8,
    marginTop: 8,
  },
  cardList_Delete: {
    cursor: "pointer",
    backgroundColor: "#ffebee",
    color: "#ef5350",
    width: 40,
    height: 40,
    marginRight: 8,
    marginTop: 8,
  },
  cardList_achieved: {
    cursor: "pointer",
    backgroundColor: "#fbe9e7",
    color: "#ff5722",
    width: 40,
    height: 40,
    marginRight: 8,
  },
  cardList_KR: {
    backgroundColor: "#ffebee",
    color: "#f44336",
  },
  paper: {
    boxShadow: "rgb(90 114 123 / 11%) 0px 7px 30px 0px",
    borderRadius: 20,
    transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    marginTop: 16,
    padding: 20,
  },
}));

const ContainerStyled = styled(Container)({
  marginTop: "100px",
});

function OrganizationPlanList() {
  const history = useHistory();
  const classes = useStyles();
  const dispatch = useDispatch();
  const { result: orgPlanStore } = useSelector((state) => state.OrgPlans);

  const [planList, setPlanList] = useState([]);
  const [planItems, setPlanItems] = useState([]);
  const [searchKey, setSearchKey] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(5);

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = planList.slice(indexOfFirstPost, indexOfLastPost);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });

  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });

  const onDeleteOrgPlan = async (formData) => {
    await dispatch(deleteOrgPlan(formData));
  };

  const onDelete = (id) => {
    //Delete OrgPlan
    onDeleteOrgPlan(id);
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
    setNotify({
      isOpen: true,
      message: "Deleted Successfully",
      type: "success",
    });
    fetchData();
  };

  const fetchData = () => {
    dispatch(getAllOrgPlan());
  };

  useEffect(() => {
    if (orgPlanStore) {
      let orgPlanList = [...orgPlanStore];
      orgPlanList.forEach((plan) => {
        plan.createBy = `${plan.firstName} ${plan.lastName}`;
      });

      orgPlanList.sort(function (a, b) {
        return new Date(b.dateCreate) - new Date(a.dateCreate);
      });

      setPlanItems(orgPlanList);
      setPlanList(orgPlanList);
      setIsLoading(false);
    }
  }, [orgPlanStore]);

  useEffect(() => {
    let x = [...planItems];
    x = x.filter((y) => {
      return y.objectiveName
        .toLowerCase()
        .includes(searchKey.toLocaleLowerCase());
    });
    setPlanList(x);
  }, [searchKey]);

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <ContainerStyled>
      <div className="card-section">
        <div className="header-section">
          <Grid container>
            <Grid item>
              <h3 className="header-topic">Organization Plan List</h3>
            </Grid>
          </Grid>
        </div>
        <Toolbar>
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item xs={6} md={8} sm={6}>
              <Button
                variant="outlined"
                className={classes.newBtn}
                onClick={() => {
                  history.push({
                    pathname: "/organization",
                    state: { planList: undefined },
                  });
                }}
              >
                Add New OKR
              </Button>
            </Grid>
            <Grid item xl={4} md={4} lg={4} sm={6} xs={12}>
              <TextField
                variant="outlined"
                style={{ width: "100%" }}
                label="Search Objective"
                value={searchKey}
                onChange={(e) => setSearchKey(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </Grid>
        </Toolbar>
      </div>
      {isLoading ? (
        <LinearProgress />
      ) : (
        <>
          {(planList.length > 0 &&
            currentPosts.map((item) => {
              return (
                <div key={item.planOrgId}>
                  <Typography
                    variant="h6"
                    style={{ marginTop: "50px" }}
                    className="keyResult"
                  >
                    <FlagIcon fontSize="large" className="svgKey" />
                    Objective
                  </Typography>
                  <div className="cardPlan_Objective">
                    <Grid
                      container
                      alignItems="flex-start"
                      alignContent="space-between"
                    >
                      <Grid item xs={3} sm={2} md={1} lg={1} xl={1}>
                        <Avatar className={classes.quater}>
                          {item.quater}
                        </Avatar>
                      </Grid>
                      <Grid item xs={7} sm={7} md={8} lg={8} xl={8}>
                        <Typography
                          className={classes.PlanList_Object}
                          gutterBottom
                        >
                          {item.objectiveName}
                        </Typography>
                      </Grid>
                      <Grid
                        container
                        item
                        xs={2}
                        sm={3}
                        md={3}
                        lg={3}
                        xl={3}
                        justifyContent="flex-end"
                      >
                        <Avatar
                          className={classes.viewBtn}
                          onClick={() => {
                            history.push({
                              pathname: "/organization",
                              state: { planList: item },
                              isInfo: true,
                            });
                          }}
                        >
                          <SearchIcon />
                        </Avatar>
                        {item.achieveResult == null ? (
                          <>
                            <Avatar
                              className={classes.cardList_Edit}
                              onClick={() => {
                                history.push({
                                  pathname: "/organization",
                                  state: { planList: item },
                                });
                              }}
                            >
                              <EditRoundedIcon />
                            </Avatar>
                            <Avatar
                              className={classes.cardList_Delete}
                              onClick={() => {
                                setConfirmDialog({
                                  isOpen: true,
                                  title: "Are you sure you want to delete ?",
                                  subTitle: "You can't undo this operation",
                                  onConfirm: () => {
                                    onDelete(item.planOrgId);
                                  },
                                });
                              }}
                            >
                              <DeleteForeverIcon />
                            </Avatar>
                          </>
                        ) : null}
                      </Grid>
                    </Grid>
                    <Grid container>
                      <Grid item xs={2} sm={2} md={1} lg={1} xl={1}></Grid>
                      <Grid item xs={10} sm={10} md={8} lg={8} xl={8}>
                        <Typography className={classes.PlanList_Status}>
                          {item.impactName}
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid container>
                      <Grid item xs={2} sm={2} md={1} lg={1} xl={1}></Grid>
                      <Grid item xs={10} sm={10} md={8} lg={8} xl={8}>
                        <ShowMiniData
                          date={item.dateCreate}
                          status={item.planStatus}
                          progress={item.achieveResult}
                        />
                      </Grid>
                    </Grid>
                  </div>
                  <Typography variant="h6" className="keyResult">
                    <VpnKeyRoundedIcon fontSize="large" className="svgKey" />
                    Key Result
                  </Typography>
                  <div className="cardPlan">
                    <Grid container alignItems="center">
                      <Grid item xs={2} md={1} lg={1} xl={1} sm={2}>
                        <Avatar className={classes.cardList_KR}>
                          <KeyboardArrowRightIcon />
                        </Avatar>
                      </Grid>
                      <Grid item xs={10} md={8} lg={11} xl={11} sm={10}>
                        <Typography className={classes.PlanList_KR}>
                          {item.keyResult1}
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid container>
                      <Grid item xs={2} sm={2} md={1} lg={1} xl={1}></Grid>
                      <Grid item xs={10} sm={10} md={8} lg={8} xl={8}>
                        <ShowMiniData
                          date={item.dateCreate}
                          status={item.kR1Status}
                          progress={item.achieveResultKR1}
                        />
                      </Grid>
                    </Grid>
                  </div>
                  {item.keyResult2 ? (
                    <div className="cardPlan">
                      <Grid container alignItems="center">
                        <Grid item xs={2} md={1} lg={1} xl={1} sm={2}>
                          <Avatar className={classes.cardList_KR}>
                            <KeyboardArrowRightIcon />
                          </Avatar>
                        </Grid>
                        <Grid item xs={10} md={8} lg={11} xl={11} sm={10}>
                          <Typography className={classes.PlanList_KR}>
                            {item.keyResult2}
                          </Typography>
                        </Grid>
                      </Grid>
                      <Grid container>
                        <Grid item xs={2} sm={2} md={1} lg={1} xl={1}></Grid>
                        <Grid item xs={10} sm={10} md={8} lg={8} xl={8}>
                          <ShowMiniData
                            date={item.dateCreate}
                            status={item.kR2Status}
                            progress={item.achieveResultKR2}
                          />
                        </Grid>
                      </Grid>
                    </div>
                  ) : null}
                  {item.keyResult3 ? (
                    <div className="cardPlan" style={{ marginBottom: "30px" }}>
                      <Grid container alignItems="center">
                        <Grid item xs={2} md={1} lg={1} xl={1} sm={2}>
                          <Avatar className={classes.cardList_KR}>
                            <KeyboardArrowRightIcon />
                          </Avatar>
                        </Grid>
                        <Grid item xs={10} md={8} lg={11} xl={11} sm={10}>
                          <Typography className={classes.PlanList_KR}>
                            {item.keyResult3}
                          </Typography>
                        </Grid>
                      </Grid>
                      <Grid container>
                        <Grid item xs={2} sm={2} md={1} lg={1} xl={1}></Grid>
                        <Grid item xs={10} sm={10} md={8} lg={8} xl={8}>
                          <ShowMiniData
                            date={item.dateCreate}
                            status={item.kR3Status}
                            progress={item.achieveResultKR3}
                          />
                        </Grid>
                      </Grid>
                    </div>
                  ) : null}
                </div>
              );
            })) || (
            <div className="cardPlan">
              <Grid container justifyContent="center">
                <Grid item>
                  <Typography variant="h6" className={classes.noData_Section}>
                    <FindInPageIcon className={classes.noDataSvg} />
                    No Data
                  </Typography>
                </Grid>
              </Grid>
            </div>
          )}
          {planList.length > 0 ? (
            <Pagination
              paginate={paginate}
              postsPerPage={postsPerPage}
              totalPosts={planList.length}
            />
          ) : null}
          <Notification notify={notify} setNotify={setNotify} />
          <ConfirmDialog
            confirmDialog={confirmDialog}
            setConfirmDialog={setConfirmDialog}
          />
        </>
      )}
    </ContainerStyled>
  );
}

export default OrganizationPlanList;
